import React, { useState, useEffect, useCallback } from "react";
import FooterDashboard from "../../part/footer.dashboard";
import { useParams } from "react-router-dom";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import PaymentDescript from "../../part/paymentdescript";
import TutorDashMenu from "../../part/tutor_dash_menu";
import TermsCondition from "../../part/terms_condition";

const TutorDescriptPayment = () => {
    const getInitialMenuCoverWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    };
    const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());
    const { course_id } = useParams();

    // const [courses, setCourses] = useState([]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const accessToken = localStorage.getItem("accessToken");

    //         try {
    //             const response = await axios.get("https://geoacademy.pythonanywhere.com/api/tutor/courses/", {
    //                 headers: {
    //                     Authorization: `Bearer ${accessToken}`,
    //                 },
    //             });
    //             setCourses(response.data);
    //         } catch (error) {
    //             console.error("Error fetching courses:", error);
    //         }
    //     };
    //     fetchData();
    // }, [course_id]);

    // refresh the api in other page 

    // it end here 

    const handleResize = useCallback(() => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            setMenuCoverWidth(menuCover.offsetWidth);
        }
    }, []);



    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);

        };
    }, [handleResize]);


    // the add button control




    return (
        <div className="dashboard">
            <DashSearchHeader onResize={handleResize} />
            <TutorDashMenu />
            <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }}>
                <PaymentDescript course_id={course_id} />
                <FooterDashboard  />
              
                <Policy />
                <TermsCondition/>
            </div>

        </div>
    );
};

export default TutorDescriptPayment;